export const lang = {
    home: "Q&A",
    account: {
        title: "Account",
        vip: {
            title: "VIP",
            url: "../../static/img/en/0.png"
        },
        forget: {
            title: "Forget password",
            url: "../../static/img/en/1.png"
        },
        active: {
            title: "Activity index",
            url: "../../static/img/en/2.png"
        }
    },
    props: {
        title: "Treasure",
        history: {
            title: "History",
            url: "../../static/img/en/3.png"
        },
        bag: {
            title: "Lucky bag",
            url: "../../static/img/en/4.png"
        },
        backpack: {
            title: "Bagpack",
            url: "../../static/img/en/5.png"
        },
        card: {
            title: "Treasure card",
            url: "../../static/img/en/6.png"
        }
    },
    chat: {
        title: "Chat",
        big: {
            title: "Super horn",
            url: "../../static/img/en/7.png"
        },
        push: {
            title: "Push notice",
            url: "../../static/img/en/8.png"
        },
        red: {
            title: "Red envelopes",
            url: "../../static/img/en/9.png"
        },
        chat: {
            title: "Chat",
            url: "../../static/img/en/10.png"
        }
    },
    game: {
        title: "Game",
        keep: {
            title: "Reserved seat",
            url: "../../static/img/en/11.png"
        },
        scratch: {
            title: "Happy scratch off",
            url: "../../static/img/en/12.png"
        },
        jackpot: {
            title: "Jackpot",
            url: "../../static/img/en/13.png"
        },
        choice: {
            title: "Game machine lobby",
            url: "../../static/img/en/14.png"
        }
    },
    bank: {
        title: "Bank",
        forgetPass: {
            title: "Forget gifting password",
            url: "../../static/img/en/15.png"
        },
        trade: {
            title: "Gifting",
            url: "../../static/img/en/16.png"
        },
        tradeList: {
            title: "Gifting list",
            url: "../../static/img/en/17.png"
        },
        tradeLimit: {
            title: "Gifting limit",
            url: "../../static/img/en/18.png"
        }
    }
}


// WEBPACK FOOTER //
// ./src/i18n/en.js